import type { DateSelection } from '@withjoy/joykit';
import { parse, set } from 'date-fns';

export const combineDateAndTime = (date: DateSelection, time: string): DateSelection => {
  if (!date) {
    return null;
  }

  const parsedTime = parse(time, 'HH:mm', new Date());
  if (isNaN(parsedTime.getTime())) {
    return date;
  }

  return set(date, {
    hours: parsedTime.getHours(),
    minutes: parsedTime.getMinutes(),
    seconds: 0,
  });
};
